import {Injectable, Inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {filter, map, Observable} from 'rxjs';
import {VisitPlanHttpService} from "./visit-plan-http.service";
import {VisitPlanModel} from "../../models/visit-plan.model";
import {
  VisitPlanActions,
  VisitPlanAPiActions,
  VisitPlanChannelActions
} from "../state/visit-plan-state/visit-plan.actions";
import {visitPlanFeature} from "../state/visit-plan-state/visit-plan.state";
import {CommonsFacadeService} from "../../../commons/angular/state/commons/commons-facade.service";
import {VisitScheduleResourceModel} from "../../models/visit-schedule-resource.model";
import {VisitScheduleResourcesParamsModel} from "../../models/visit-schedule-params.model";
import {VisitScheduleModel} from "../../models/visit-schedule.model";
import {VisitScheduleDayModel} from "../../models/visit-schedule-day.model";
import {
  VisitScheduleActions,
  VisitScheduleAPiActions, VisitScheduleChannelActions
} from "../state/visit-plan-schedule-state/visit-plan-schedule.actions";
import {VisitPlanAccountActions} from "../state/visit-plan-account-state/visit-plan-account.actions";
import {visitScheduleFeature} from "../state/visit-plan-schedule-state/visit-plan-schedule.state";
import {visitPlanAccountFeature} from "../state/visit-plan-account-state/visit-plan-account.state";
import {ItineraryModel} from "../../../itineraries/angular/models/itinerary.model";
import {itinerariesFeature} from "../../../itineraries/angular/state/itineraries.state";
import {VisitScheduleRoutesChannelService} from "./visit-schedule-routes-channel.service";

@Injectable()
export class VisitScheduleFacadeService {

  constructor(@Inject(Store) private store: Store,
              @Inject(VisitPlanHttpService) private visitPlanHttpService: VisitPlanHttpService,
              @Inject(VisitScheduleRoutesChannelService) private visitScheduleRoutesChannelService: VisitScheduleRoutesChannelService,
              @Inject(CommonsFacadeService) private commonsFacadeService: CommonsFacadeService) {
  }

  getVisitSchedule(visitPlanId: string, visitScheduleId: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(VisitScheduleAPiActions.getVisitSchedule({visitPlanId, visitScheduleId, isSubscribeToChannel}));
  }


  setOne(visitSchedule: VisitScheduleModel, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(VisitScheduleActions.setOne({visitSchedule, isSubscribeToChannel}));
  }

  selectOne(scheduleId: string): Observable<VisitScheduleModel> {
    return this.store.select(visitScheduleFeature.selectEntities)
      .pipe(
        map(entities => entities[scheduleId]),
        filter((v): v is VisitScheduleModel => !!v), // ignore undefined
      )
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(visitScheduleFeature.selectIsLoading());
  }

  subscribeToChannels(): void {
    this.store.dispatch(VisitScheduleChannelActions.subscribe());
  }

  subscribeToRoutesChannels(): void {
    this.visitScheduleRoutesChannelService.getChannelsValues();
  }

  clearStore(): void {
    this.store.dispatch(VisitScheduleActions.clearStore());
  }

  syncVisitSchedule(visitPlanId: string, visitScheduleId: string): Observable<VisitScheduleDayModel[]> {
    return this.visitPlanHttpService.syncVisitSchedule(visitPlanId, visitScheduleId)
  }

}
